export default __webpack_public_path__ + "static/media/finance4.42174656.svg";